export class RqInputPerson {
    firstName?: string | undefined
    middleName?: string | undefined
    lastName?: string | undefined
    birthDate?: string | undefined

    constructor(firstName: string | undefined, middleName: string | undefined, lastName: string | undefined, birthDate: string | undefined) {
        this.firstName = firstName;
        this.middleName = middleName;
        this.lastName = lastName;
        this.birthDate = birthDate;
    }

    static empty(): RqInputPerson {
        return new RqInputPerson(undefined, undefined, undefined, undefined)
    }

}